//import { Notification } from "element-ui";
import { api } from "../gateways/unilabApi";

export default {
  getSingleTranslation(language,key){
    return new Promise((resolve, reject) => {
      api
        .get(`translation/${language}/${key}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getTranslations(language) {
    console.log("getTranslations > " + language);
    return new Promise((resolve, reject) => {
      api
        .get(`translation/${language}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
